export const THEME_CLASSES = {

  race: {
    // Race summary panel
    summary: {
      container: 'bg-gray-50 dark:bg-gray-800/50',
      label: 'text-gray-600 dark:text-gray-400',
      value: {
        positive: 'text-green-600 dark:text-green-400',
        negative: 'text-red-600 dark:text-red-400',
        neutral: 'text-gray-900 dark:text-gray-100'
      }
    },

    // Stable boy advice panel
    advice: {
      container: 'bg-amber-50 dark:bg-amber-900/20',
      text: 'text-amber-900 dark:text-amber-100'
    },

    // Monthly record alert
    record: {
      container: 'bg-yellow-50 dark:bg-yellow-900/20 border-2 border-yellow-500 dark:border-yellow-600',
      title: 'text-yellow-800 dark:text-yellow-100',
      text: 'text-yellow-700 dark:text-yellow-200'
    },

    // Position indicators
    position: {
      first: {
        bg: 'bg-yellow-100 dark:bg-yellow-900/50 border-yellow-500 dark:border-yellow-600',
        text: 'text-yellow-800 dark:text-yellow-200',
        badge: 'bg-yellow-500 dark:bg-yellow-600 text-white dark:text-yellow-100 shadow-sm ring-2 ring-yellow-500/50 dark:ring-yellow-500/20'
      },
      second: {
        bg: 'bg-gray-100 dark:bg-gray-800/50 border-gray-500 dark:border-gray-400',
        text: 'text-gray-800 dark:text-gray-200',
        badge: 'bg-gray-500 dark:bg-gray-400 text-white dark:text-gray-100 shadow-sm ring-2 ring-gray-500/50 dark:ring-gray-400/20'
      },
      third: {
        bg: 'bg-amber-100 dark:bg-amber-900/50 border-amber-700 dark:border-amber-600',
        text: 'text-amber-800 dark:text-amber-200',
        badge: 'bg-amber-700 dark:bg-amber-600 text-white dark:text-amber-100 shadow-sm ring-2 ring-amber-700/50 dark:ring-amber-600/20'
      },
      other: {
        bg: 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700',
        text: 'text-gray-600 dark:text-gray-400',
        badge: 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
      }
    },

    // Level up notification
    levelUp: {
      container: 'bg-yellow-100 dark:bg-yellow-900/30 border-t border-yellow-200 dark:border-yellow-800',
      title: 'text-yellow-800 dark:text-yellow-100',
      stat: {
        speed: 'text-green-700 dark:text-green-400',
        stamina: 'text-green-700 dark:text-green-400',
        behavior: 'text-purple-700 dark:text-purple-400'
      }
    },

    // Time and experience display
    stats: {
      container: 'bg-blue-50 dark:bg-blue-900/20 border-t border-blue-100 dark:border-blue-800',
      text: 'text-blue-700 dark:text-blue-300',
      highlight: 'text-yellow-600 dark:text-yellow-400 font-bold'
    },

    // Player indicator tag
    playerTag: 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-200',

    // NPC notifications overlay
    notifications: {
      container: 'bg-white dark:bg-gray-800',
      message: 'text-gray-700 dark:text-gray-300',
      counter: 'text-gray-500 dark:text-gray-400',
      button: {
        next: 'bg-blue-500 dark:bg-blue-600 text-white hover:bg-blue-600 dark:hover:bg-blue-700',
        close: 'bg-gray-500 dark:bg-gray-600 text-white hover:bg-gray-600 dark:hover:bg-gray-700'
      },
      badge: 'bg-amber-400 dark:bg-amber-500 text-amber-800 dark:text-amber-100'
    }
  },
    // Base page/layout colors
    layout: {
      page: 'bg-gray-100 dark:bg-gray-900',
      card: 'bg-white p-6 mb-6 dark:bg-gray-800 p-6 mb-6"',
      cardHover: 'hover:bg-gray-50 dark:hover:bg-gray-700',
      divider: 'border-gray-200 dark:border-gray-700',
    },
    
    // Text colors
    text: {
      primary: 'text-gray-900 font-bold text-xl mb-4 dark:text-gray-100 font-bold mb-4 text-xl',
      primaryLow: 'text-gray-900 font-semibold mb-4 dark:text-gray-100 font-semibold mb-4',
      secondaryBold: 'text-gray-600 font-semibold dark:text-gray-400 font-semibold',
      secondary: 'text-gray-600 dark:text-gray-400',
      money: 'text-yellow-500 font-semibold',
      tertiary: 'text-gray-500 dark:text-gray-500',
    },
    
    // Form elements
    form: {
      input: 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400',
      select: 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400',
      button: {
        primary: 'bg-blue-600 hover:bg-blue-700 dark:bg-blue-800 dark:hover:bg-blue-900 text-white',
        secondary: 'bg-gray-600 hover:bg-gray-700 dark:bg-gray-700 dark:hover:bg-gray-800 text-white',
        outline: 'px-2 py-1 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 text-sm',
        race: 'px-2 py-1 bg-green-600 hover:bg-green-700 dark:bg-green-800 dark:hover:bg-green-900 text-white text-sm',
        transit: 'px-2 py-1 bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-800 dark:hover:bg-indigo-900 text-white text-sm',
        breed: 'px-2 py-1 bg-purple-600 hover:bg-purple-700 dark:bg-purple-800 dark:hover:bg-purple-900 text-white text-sm',
        mobile: 'w-full text-left px-3 py-2 text-sm hover:bg-gray-100 text-gray-700 dark:text-gray-200 dark:hover:bg-gray-700'
      }
    },
  
    // Common components
    components: {
      modal: {
        overlay: 'bg-black/50 dark:bg-black/60',
        container: 'bg-white dark:bg-gray-800',
      },
      dropdown: {
        menu: 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700',
        item: 'hover:bg-gray-100 dark:hover:bg-gray-700',
      },
      table: {
        header: 'bg-gray-50 dark:bg-gray-700',
        row: 'border-gray-200 dark:border-gray-700',
        rowHover: 'hover:bg-gray-50 dark:hover:bg-gray-700',
      }
    }
  };  
  
  export const applyThemeClasses = (path) => {
    const parts = path.split('.');
    let result = THEME_CLASSES;
    
    for (const part of parts) {
      if (result && typeof result === 'object') {
        result = result[part];
      } else {
        return '';
      }
    }
    
    return typeof result === 'string' ? result : '';
  };